import React,{Component} from 'react';
import { AnimationOnScroll } from 'react-animation-on-scroll';

import section from "../../../images/team/banner.jpg";

import imgAlif from "../../../images/team_new/alif_hastono.jpg";
import imgFaishal from "../../../images/team_new/muhammad_faishal.jpg";
import imgAhmad from "../../../images/team_new/ahmad_fauzi.jpg";
import imgTomy from "../../../images/team_new/tomy_petirandi_w.jpg";
import imgAnwar from "../../../images/team_new/anwar_hendarto.jpg";
import imgJunor from "../../../images/team_new/junor_maulana_a.jpg";
import imgItzur from "../../../images/team_new/itzur_zulmart_t.jpg";
import imgJawhari from "../../../images/team_new/ahmad_jawhari_f.jpg";
import imgAlifian from "../../../images/team_new/alifian_aji_s.jpg";
import imgHanif from "../../../images/team_new/hanif_rizqi_m.jpg";
import imgRenaldio from "../../../images/team_new/renaldio_pradipta_p.jpg";
import imgJoshean from "../../../images/team_new/joshean_devin_a.jpg";
import imgZhafran from "../../../images/team_new/zhafran_fajar_b.jpg";
import imgVincent from "../../../images/team_new/vincent_collin.jpg";
import imgMuchlis from "../../../images/team_new/muchlis_rumalutur.jpg";

import imgBilal from "../../../images/team_new/m_bilal_selostannu.jpg";
import imgNathania from "../../../images/team_new/nathania_rismauli.jpg";
import imgAryo from "../../../images/team_new/aryo_nuugraha.jpg";
import imgGhaisani from "../../../images/team_new/ghaisani_khoirunnisa.jpg";
import imgDenny from "../../../images/team_new/denny_ilyas.jpg";
import imgNurul from "../../../images/team_new/nurul_angelia.jpg";

import imgAstri from "../../../images/team_new/astri_cahyanti.jpg";
import imgClarima from "../../../images/team_new/clarima_flourenza.jpg";
import imgMeylani from "../../../images/team_new/meylani.jpg";

import {history} from "../../../shared/configure-store";

require('dotenv').config();

class About extends Component {

    constructor(props) {

        super(props);

        this.state = {
            isOpen: false,
            photoIndex: 0,
            teamSections: [
                {
                    title: 'Executive Leadership',
                    members: [
                        {
                            name: 'Alif Hastono',
                            title: 'Director',
                            email: 'alifhastono@abadisurvey.com',
                            image: imgAlif,
                        },
                        {
                            name: 'Muhammad Faishal',
                            title: 'Vice President',
                            email: 'm.faishal@abadisurvey.com',
                            image: imgFaishal,
                        },
                    ],
                },
                {
                    title: 'SURVEYOR',
                    members: [
                        {
                            name: 'Ahmad Fauzi',
                            title: 'Senior Surveyor',
                            email: 'ahmadfauzi@abadisurvey.com',
                            image: imgAhmad,
                        },
                        {
                            name: 'Tomy Wijaya',
                            title: 'Surveyor',
                            email: '',
                            image: imgTomy,
                        },
                        {
                            name: 'Anwar Hendarto',
                            title: 'Surveyor',
                            email: '',
                            image: imgAnwar,
                        },
                        {
                            name: 'Junor Maulana A.',
                            title: 'Surveyor',
                            email: '',
                            image: imgJunor,
                        },
                        {
                            name: 'Alifian Aji S.',
                            title: 'Surveyor',
                            email: '',
                            image: imgAlifian,
                        },
                        {
                            name: 'Itzur Zulmart T.',
                            title: 'Surveyor',
                            email: '',
                            image: imgItzur,
                        },
                        {
                            name: 'Ahmad Jawhari F.',
                            title: 'Surveyor',
                            email: '',
                            image: imgJawhari,
                        },
                        {
                            name: 'Hanif Rifqi M.',
                            title: 'Surveyor',
                            email: '',
                            image: imgHanif,
                        },
                        {
                            name: 'Zhafran Fajar B.',
                            title: 'Surveyor',
                            email: '',
                            image: imgZhafran,
                        },
                        {
                            name: 'Vincent Collin',
                            title: 'Surveyor',
                            email: '',
                            image: imgVincent,
                        },
                        {
                            name: 'Renaldio Pradipta P.',
                            title: 'Surveyor',
                            email: '',
                            image: imgRenaldio,
                        },
                        {
                            name: 'Muchlis Rumalutur',
                            title: 'Surveyor',
                            email: '',
                            image: imgMuchlis,
                        },
                        {
                            name: 'Joshean Devin',
                            title: 'Surveyor',
                            email: '',
                            image: imgJoshean,
                        },

                    ],
                },
                {
                    title: 'OPERATION',
                    members: [
                        {
                            name: 'Bilal Selostannu',
                            title: 'Manager Operation',
                            email: 'bilal@abadisurvey.com',
                            image: imgBilal,
                        },
                        {
                            name: 'Nathania Rismauli',
                            title: 'Spv. Approval',
                            email: 'nathania@abadisurvey.com',
                            image: imgNathania,
                        },
                        {
                            name: 'Aryo Septya N.',
                            title: 'Spv. Approval',
                            email: 'aryo.nugraha@abadisurvey.com',
                            image: imgAryo,
                        },
                        {
                            name: 'Ghaisani Khoirunnisa',
                            title: 'Approval Officer',
                            email: '',
                            image: imgGhaisani,
                        },
                        {
                            name: 'Denny Ilyas',
                            title: 'Admin Operation Officer',
                            email: '',
                            image: imgDenny,
                        },
                        {
                            name: 'Nurul Angelia',
                            title: 'Admin Officer',
                            email: '',
                            image: imgNurul,
                        },
                    ],
                },
                {
                    title: 'FINANCE',
                    members: [
                        {
                            name: 'Astri Cahyanti',
                            title: 'Head of Finance',
                            email: 'astricahyanti@abadisurvey.com',
                            image: imgAstri,
                        },
                        {
                            name: 'Clarima Flourenza',
                            title: 'Collection Officer',
                            email: '',
                            image: imgClarima,
                        },
                        {
                            name: 'Meylani',
                            title: 'Invoicing Officer',
                            email: '',
                            image: imgMeylani,
                        },
                    ],
                },
            ],
        };

        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {

        document.title = 'Abadi Cemerlang - Our Team';

    }


    handleChange (e, prop){

        this.setState({

            [prop]: e.target.value

        });

    };

    handleOpen = (row) => {

        this.setState({
            showDialog :true,
            idDelete: row.id,
            currDelete: row.title,
        })
    };

    handleClose = () => {
        this.setState({
            showDialog :false,
        })
    };


    handleGo = (link) => {

        history.push(link);
    };


    render() {
        return (
            <div>
                <section className="section-banner service" style={{backgroundImage: `url(${section})`}}>
                    <div className='container'>
                        <div className='row '>
                            <div className='col-md-10'>
                                <AnimationOnScroll animateIn="animate__fadeInUp">
                                <div className='content text-left'>
                                    <h1>OUR TEAM</h1>
                                    <p>We are proud of our team of motivated professionals, with highly qualified Naval Architects and Marine Engineering combined with technical expertise and practical experience, working together as a team supported by our administration and management support with backgrounds in their respective fields. </p>
                                    <p>We pay attention to our customers and make all efforts to improve our service to obtain maximum performance. We are aware our customers require immediate service and accuracy. We should welcome the opportunity to share our knowledge and expertise with your company to sharpen your competitive edge in a very dynamic business situation. If you need best in class execution, please contact us anytime whenever you wish.</p>
                               </div>
                                </AnimationOnScroll>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="section-content">
                    <div className='container'>
                        <div className='row mb-5 justify-content-center'>
                            <div className='col-md-10 text-center'>
                                <p className='mb-3'>We pay attention to our customers and make all efforts to improve our service to obtain maximum performance. We are aware our customers require immediate service and accuracy. We should welcome the opportunity to share our knowledge and expertise with your company to sharpen your competitive edge in a very dynamic business situation. If you need best in class execution, please contact us anytime whenever you wish. Our Surveyors are always at your disposal to be contacted 24 hours a day and 7 days a week the whole year.</p>
                            </div>
                        </div>
                        {this.state.teamSections.map((section, sectionIndex) => {
                            const isExecutive = section.title === 'Executive Leadership';
                            const colClass = isExecutive ? 'col-md-6' : 'col-md-4';

                            return (
                            <div className='team-section mb-5' key={section.title}>
                                <h2 className='team-section-title'>{section.title}</h2>
                                <div className={`row ${isExecutive ? 'justify-content-center' : ''}`}>
                                    {section.members.map((row, id) => (
                                        <div className={colClass} key={`${sectionIndex}-${id}`}>
                                            <div className='card-team'>
                                                <div className='img-team-wrap'>
                                                    <img src={row.image} className='img-team' alt={row.name} />
                                                </div>
                                                <div className='team-detail'>
                                                    <h3 className='team-name'>{row.name}</h3>
                                                    <p className='team-role'>{row.title}</p>
                                                    {row.email ? <p className='team-email'>{row.email}</p> : null}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            );
                        })}
                    </div>
                </section>
            </div>

        )
    }
}

export default About;
